<template>
  <div class="life_costs-pages-pay-history content-container" id="life_costs-pages-pay-history">
    <div class="container-scroll">
      <!--导航部分-->
      <section class="layout-pad-full layout-margin-bottom back-white">
        <a-breadcrumb>
          <a-breadcrumb-item>首页</a-breadcrumb-item>
          <a-breadcrumb-item>生活中心</a-breadcrumb-item>
          <a-breadcrumb-item>
            <a href="javascript:;" @click.stop="previousPageEvt">账单管理</a>
          </a-breadcrumb-item>
          <a-breadcrumb-item>缴费历史</a-breadcrumb-item>
        </a-breadcrumb>
      </section>
      <!--导航部分 end-->
      <!--search部分-->
      <section class="layout-pad-full layout-pad-top-nil layout-margin-bottom back-white">
        <h1 class="holder-title">搜索条件</h1>
        <a-form class="cabinvue-search-form">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
              <div class="search-form-item">
                <div class="item-label">
                  <span>收款日期：</span>
                </div>
                <div class="item-control">
                  <a-select
                      show-search
                      placeholder="请选择收款日期"
                      option-filter-prop="children"
                      v-model="condition.payDateScope"
                      :filter-option="filterOption"
                    >
                      <a-select-option :value="item.code" v-for="item in pageData.payDateScopeList" :key="item.code">{{item.name}}</a-select-option>
                    </a-select>
                </div>
              </div>
            </a-col>
            <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
              <div class="search-form-item">
                <div class="item-label">
                  <span>自定义收款日期：</span>
                </div>
                <div class="item-control">
                  <a-range-picker
                    :disabled="condition.payDateScope !== '0'"
                    v-model="pageData.payDate"
                    @change="payDateChange"
                    :ranges="{ 
                      '今天': [$moment().startOf('day'), $moment().endOf('day')],
                      '昨天': [$moment().subtract(1, 'days').startOf('day'), $moment().subtract(1, 'days').endOf('day')],
                      '最近一周': [$moment().subtract(7, 'days').startOf('day'), $moment().endOf('day')],
                      '本月': [$moment().startOf('month'), $moment().endOf('month')] 
                    }"
                    format="YYYY-MM-DD"
                    :placeholder="['开始日期', '结束日期']"
                  />
                </div>
              </div>
            </a-col>
          </a-row>
          <hr />
          <div class="form-option-area">
            <a-button icon="search" class="space-margin-right" type="primary" :loading="tableObj.tableLoading" @click.stop="search">查询</a-button>
            <a-button icon="reload" class="space-margin-right btn-outline" @click.stop="resetEvt">重置</a-button>
          </div>
        </a-form>
      </section>
      <!--search部分 end-->
      <!--表格部分-->
      <section class="layout-pad-full layout-margin-bottom back-white">
        <a-table
          @expand="expandTableEvt"
          :expanded-row-keys="tableObj.expandedRowKeys"
          :scroll="scroll"
          class="J_compensation_list_table"
          :columns="tableObj.columns" 
          :data-source="tableObj.list"
          :pagination="false"
          :loading="tableObj.tableLoading" 
          
        >
          <div slot="expandedRowRender" slot-scope="record, index, indent, expanded">
            <a-row class="expanded-row" :gutter="24" v-for="(item,index) in children" :key="index">
              <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                <p class="detail-para">账单ID串：{{item.acctItemStr}}</p>
              </a-col>
              <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                <p class="detail-para">资源类型：{{item.billObjType}}</p>
              </a-col>
              <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                <p class="detail-para">账期：{{item.billingCycle}}</p>
              </a-col>
              <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                <p class="detail-para">账期小计金额：{{item.cycleTotalFee}}</p>
              </a-col>
              <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                <p class="detail-para">本金：{{item.fee}}</p>
              </a-col>
              <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                <p class="detail-para">费用科目ID：{{item.feeItemTypeId}}</p>
              </a-col>
              <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                <p class="detail-para">费用科目名称：{{item.feeItemTypeName}}</p>
              </a-col>
              <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                <p class="detail-para">违约金：{{item.lfree}}</p>
              </a-col>
              <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                <p class="detail-para">滞纳金总额：{{item.lfreeTotalFee}}</p>
              </a-col>
              <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                <p class="detail-para">资源ID：{{item.resInstId}}</p>
              </a-col>
              <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                <p class="detail-para">资源名称：{{item.resInstName}}</p>
              </a-col>
            </a-row>
          </div>
        </a-table>
        <div class="clearfix">
          <a-pagination 
            style="margin-top:8px;float: right;" 
            show-size-changer 
            @change="pagination.change"
            @showSizeChange="pagination.showSizeChange"
            :default-current="pagination.defaultCurrent"
            v-model="pagination.current"
            :defaultPageSize = "pagination.defaultPageSize"
            :total="pagination.total"
            :show-quick-jumper="pagination.showQuickJumper"
            :page-size-options="pagination.pageSizeOptions"
            :show-total='pagination.showTotal'>
          </a-pagination>
        </div>
      </section>
      <!--表格部分 end-->
    </div>
  </div>
</template>

<script>
import ajax from '../../lib/axios/ajax'
import { POST_PAYBILL_QUERYPAYLOGLIST, POST_PAYBILL_QUERYPAYLOGDETAILLIST } from '../../lib/axios/apilist'

export default {
  //这里必须 使用一个方法返回给data
  data () {
    // 请求地址
    let ajaxParam = {
      POST_PAYBILL_QUERYPAYLOGLIST: POST_PAYBILL_QUERYPAYLOGLIST,
      POST_PAYBILL_QUERYPAYLOGDETAILLIST: POST_PAYBILL_QUERYPAYLOGDETAILLIST,
    };
    //分页信息
    let pagination = {
      pageSize: 10,
      current: 1,
      defaultCurrent: 1,
      defaultPageSize: 10,
      total: 0,
      showQuickJumper: true,
      showTotal: total => `共${total}条数据`,
      showSizeChanger: true,
      pageSizeOptions: ['10', '30', '50', '100'],
      showSizeChange: (current, pageSize) => {
        this.pagination.pageSize = pageSize;
        this.pagination.current = current;
        this.$options.methods.search.bind(this)();
      },
      change: (page, pageSize) => {
        this.pagination.current = page;
        this.pagination.pageSize = pageSize;
        this.$options.methods.search.bind(this)(false);
      }
    };
    let pageData = {
      payDate: [],
      payDateScopeList: [{
          code: '0',
          name: '不传'
        },
        {
          code: '0-D',
          name: '当天'
        },
        {
          code: '7-D',
          name: '近一周'
        },
        {
          code: '1-M',
          name: '近一月'
        },
        {
          code: '2-M',
          name: '近两月'
        },
        {
          code: '3-M',
          name: '近三月'
        },
        {
          code: '6-M',
          name: '近半年'
        },
        {
          code: '12-M',
          name: '近一年'
        },
      ]
    };
    let condition = {
      custId: undefined, // 客户ID
      communityId: undefined, // 项目ID
      payDateScope: '3-M', // 日期范围 
      payDateStart: undefined, // 收款开始时间
      payDateEnd: undefined, // 收款结束时间
    }
    let tableObj = {
      tableLoading: false,
      expandedRowKeys: [],
      list: [],
      columns: [{
        title: '交易流水号',
        dataIndex: 'transactionNo',
      }, {
        title: '缴费流水号',
        dataIndex: 'paySerialNbr',
      }, {
        title: '收款年份',
        dataIndex: 'billingYear',
      }, {
        title: '收款员工姓名',
        dataIndex: 'empeeName',
      }, {
        title: '缴费金额',
        dataIndex: 'payAmont',
      }, {
        title: '缴费时间',
        dataIndex: 'payDate',
      }, {
        title: '支付方式',
        dataIndex: 'payMethodName',
      }, {
        title: '资源名称',
        dataIndex: 'resInstName',
      }, {
        title: '状态名称',
        dataIndex: 'stateName',
      }]
    }
    let scroll = {
      x: 1000,
    }
    return {
      pagination,
      pageData,
      condition,
      tableObj,
      ajaxParam,
      scroll,
      children: []
    }
  },
  mounted() {
    //进入页面
    //cabinVue 里面所有的this 都指向当前这个vue 实例
    //vue 更多使用方法请查看vue官方文档
    this.$nextTick(function () {
      //nextTick 用于当data数据改变,触发vue 渲染,且渲染完毕使用

    });
    this.condition.custId = this.$route.query.custId
    this.condition.communityId = this.$route.query.communityId
    this.$options.methods.search.bind(this)();
  },
  //如果 不需要保存页面状态必须添加下面这个方法
  beforeDestroy: function () {
    
  },
  destroyed: function () {
    //离开页面方法
  },
  //监听属性变化，，变量必须是data里声明的
  watch: {
    'condition.payDateScope': function (value) {
      if (value === '0') {
        this.resetEvt()
      }
    }
  },
  //监听属性变化，配置变量的同时也起到data声明的作用
  computed: {},
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    previousPageEvt() {
      this.$router.go(-1)
    },
    // table查询搜索
    search(startFlag = true, param = {}, tempPagination = this.pagination) {
      if (this.condition.payDateScope === '0') {
        if (this.condition.payDateStart === undefined ||
          this.condition.payDateStart === null ||
          this.condition.payDateStart === '' ||
          this.condition.payDateEnd === undefined ||
          this.condition.payDateEnd === null ||
          this.condition.payDateEnd === '') {
          this.$message.warning('请选择自定义收款日期');
          return false
        }
      }

      let searchParam = {
        ...this.condition
      }

      //开启加载效果
      this.tableObj.tableLoading = true;

      //浅复制
      let requestParam = Object.assign({}, searchParam, param);

      let currentPageNo = tempPagination.current;
      let currentPageSize = tempPagination.pageSize;
      if (startFlag) {
        requestParam.currentPage = 1;
      } else {
        requestParam.currentPage = currentPageNo;
      }
      requestParam.pageSize = currentPageSize;

      // 清空table数据
      this.tableObj.list.splice(0, this.tableObj.list.length);
      this.tableObj.expandedRowKeys.splice(0, this.tableObj.expandedRowKeys.length);

      let that = this;
      let successFunc = (res) => {
        // 关闭加载效果
        this.tableObj.tableLoading = false;

        if (res.code === "0000") {
          this.pagination.current = res.data.currentPage;
          this.pagination.defaultCurrent = res.data.currentPage;
          this.pagination.pageSize = res.data.pageSize;
          this.pagination.total = res.data.totalCount;
          this.tableObj.list = res.data.result.map(item => {
            return {
              ...item,
              children: []
            }
          }) || []

          //调整TABLE样式
          that.$nextTick(function () {
            //根据表格实际宽度设置scrollX
            that.scrollX = 100 * that.tableObj.columns.length;
          });
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) => {
        this.tableObj.tableLoading = false;
        this.$error({
          title: '提示',
          content: res.result,
        });
      };

      //搜索地址
      let url = this.ajaxParam.POST_PAYBILL_QUERYPAYLOGLIST;
      ajax.fetch(url, requestParam, successFunc, errorFunc)
    },
    resetEvt() {
      this.condition = {
        ...this.condition,
        payDateStart: undefined, // 收款开始时间
        payDateEnd: undefined, // 收款结束时间
      }
      this.pageData.payDate = [];
    },
    payDateChange(date, dateString) {
      if (dateString) {
        this.condition.payDateStart = dateString[0]; // 处理时间开始
        this.condition.payDateEnd = dateString[1]; // 处理时间结束
      } else {
        this.pageData.payDate = [];
      }
    },
    expandTableEvt(expanded, record) {
      if (expanded) {
        this.detailEvt(record.paySerialNbr)
      } else {
        this.tableObj.expandedRowKeys = []
      }
    },
    detailEvt(paySerialNbr) {
      //搜索地址
      let url = this.ajaxParam.POST_PAYBILL_QUERYPAYLOGDETAILLIST;
      let successFunc = (res) => {
        if (res.code === "0000") {
          this.tableObj.list.find((item, index) => {
            if (item.paySerialNbr === paySerialNbr) {
              this.tableObj.expandedRowKeys = [index]
              this.children = res.data
              return true
            } else {
              return false
            }
          })
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) => {
        this.$error({
          title: '提示',
          content: res.result,
        });
      };
      let requestParam = {
        paySerialNbr, // 缴费流水号
        communityId: this.condition.communityId // 项目ID，
      }
      //fetch ajax提交数据
      ajax.fetch(url, requestParam, successFunc, errorFunc)

    }

  }
}
</script>

<style scoped>

</style>